<div *ngIf="reviews" class="container" [class.tablet]="isTablet" [class.mobile]="isMobile"
  [class.notDesktop]="!isDesktop">
  <div class="header-container">
    <div class="header">
      <span>
        {{'Livre d\'or' | translate}}
      </span>
      <span>
        {{'Appréciation moyenne pour ' | translate}}{{reviews.length}}{{' avis: ' | translate}}{{getAverageString()}}/5
        <app-rating [rating]="average"></app-rating>
      </span>
    </div>
    <div class="button">
      <button class="wire-btn" (click)="reviewModal(reviewTemplate)">{{'Laisser un commentaire' | translate}}</button>
    </div>
  </div>
  <div class="cards">
    <app-review *ngFor="let review of reviews | paginate: config" [review]="review" (reviewDeleted)="ngOnInit()">

    </app-review>
  </div>

  <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event"
    *ngIf="reviews.length > config.itemsPerPage">
    <div class="custom-pagination">
      <div class="pagination-previous">
        <a class="paginate" [class.locked]="p.isFirstPage()" (click)="!p.isFirstPage() && p.previous()">
          <i class="fa fa-arrow-left"></i> </a>
      </div>

      <div *ngFor="let page of p.pages">
        <a (click)="p.getCurrent() !== page.value && p.setCurrent(page.value)"
          [class.current]="p.getCurrent() === page.value">
          {{ page.label }}
        </a>
      </div>

      <div class="pagination-next">
        <a class="paginate" (click)="!p.isLastPage() && p.next()" [class.locked]="p.isLastPage()"> <i
            class="fa fa-arrow-right"></i> </a>
      </div>
    </div>
  </pagination-template>
</div>

<ng-template #reviewTemplate>
  <div class="modal-content">
    <div class="header">
      {{'Laisser un commentaire' | translate}}
      <div class="close" (click)="close()">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div class="content">
      <div class="form">
        <div class="form-group">
          <div class="label">{{'Nom' | translate}}</div>
          <input type="text" [(ngModel)]="reviewModel.name" id="name" #name="ngModel" />
          <div *ngIf="name.invalid && (name.dirty || name.touched)">
            {{'Le nom est obligatoire' | translate}}
          </div>
        </div>
        <div class="form-group">
          <div class="label">{{'Commentaire' | translate}}</div>
          <textarea rows="7" [(ngModel)]="reviewModel.comment" id="comment" #comment="ngModel"></textarea>
          <div *ngIf="comment.invalid && (comment.dirty || comment.touched)">
            {{'Le commentaire est obligatoire' | translate}}
          </div>
        </div>
        <div class="form-group">
          <div class="label">{{'A séjourné en' | translate}}</div>
          <select [(ngModel)]="reviewModel.stayStartDate">
            <option [value]="'01/01/2000 08:00'">{{'Janvier' | translate}}</option>
            <option [value]="'02/01/2000 08:00'">{{'Février' | translate}}</option>
            <option [value]="'03/01/2000 08:00'">{{'Mars' | translate}}</option>
            <option [value]="'04/01/2000 08:00'">{{'Avril' | translate}}</option>
            <option [value]="'05/01/2000 08:00'">{{'Mai' | translate}}</option>
            <option [value]="'06/01/2000 08:00'">{{'Juin' | translate}}</option>
            <option [value]="'07/01/2000 08:00'">{{'Juillet' | translate}}</option>
            <option [value]="'08/01/2000 08:00'">{{'Août' | translate}}</option>
            <option [value]="'09/01/2000 08:00'">{{'Septembre' | translate}}</option>
            <option [value]="'10/01/2000 08:00'">{{'Octobre' | translate}}</option>
            <option [value]="'11/01/2000 08:00'">{{'Novembre' | translate}}</option>
            <option [value]="'12/01/2000 08:00'">{{'Décembre' | translate}}</option>
          </select>
        </div>
        <div class="form-group">
          <div class="label">{{'Evaluation globale' | translate}}</div>
          <app-rating [rating]="reviewModel.evaluation" [editable]="true" (ratingChange)="setRating($event)">
          </app-rating>
          <div *ngIf="comment.invalid && (comment.dirty || comment.touched)">
            {{'L\'évaluation est obligatoire' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="saveReview()">Save</button>
      <button class="wire-btn default" (click)="close()">Cancel</button>
    </div>
  </div>
</ng-template>